// import { MassRepeatResponsesDataContainer } from '@containers/RepeatSurveyResponses/MassSurveyDataContainer';
// import { RepeatResponsesDataContainer } from '@containers/RepeatSurveyResponses/DataContainer';
import { SurveyResponsesDataContainer } from '@/containers/SurveyResponses/DataContainer';
// import { MassSurveyResponsesDataContainer } from '@containers/SurveyResponses/MassSurveyDataContainer';
import { SurveyResponsesStateContainer } from '@/containers/SurveyResponses/SurveyResponsesState';
import { useProjectOrLatestChild } from './hooks';
// import { RepeatResponsesStateContainer } from '@containers/RepeatSurveyResponses/RepeatResponsesState';
// import { ProjectType } from '@enums';
// import { useIsMassSurvey, useProjectState, useProjectOrLatestChild } from './hooks';

export const SurveyResponsesContainer = (props: ChildrenProps) => {
  const project = useProjectOrLatestChild();

  if (!project) {
    return null;
  }

  return (
    <SurveyResponsesStateContainer>
      <SurveyResponsesDataContainer>
        {props.children}
      </SurveyResponsesDataContainer>
    </SurveyResponsesStateContainer>
  );
};
/*
const InnerContainer = (props: ChildrenProps) => {
  const state = useProjectState();
  const isMassSurvey = useIsMassSurvey();

  if (state.project) {
    const Container = isMassSurvey
      ? MassSurveyResponsesDataContainer
      : SurveyResponsesDataContainer;

    return (
      <SurveyResponsesStateContainer>
        <Container>
          {props.children}
        </Container>
      </SurveyResponsesStateContainer>
    );
  } else {
    const Container = isMassSurvey
      ? MassRepeatResponsesDataContainer
      : RepeatResponsesDataContainer;

    return (
      <RepeatResponsesStateContainer>
        <Container>
          {props.children}
        </Container>
      </RepeatResponsesStateContainer>
    );
  }
};
*/